module.exports = __webpack_public_path__ + "static/w-luffy-e3bc8b2e7d4220ae7887d7ee03d9dc16.jpg";